import { scrollToAccommodation } from 'assets/core/js/page/product/results'
import coreSearch from 'assets/core/js/page/product/search'
import recap from 'assets/themes/vacances-campings/js/page/product/search/recap'
import type { Facets } from 'assets/core/js/page/product/search/facets'

export default function (facets: Facets): void {
  coreSearch(facets)
  scrollToAccommodation()
  recap()
}
